import axios, { AxiosResponse } from "axios"

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

export function fetchHealthCheck(token: string, tenantId: number, cloud?: string, region?: string): Promise<AxiosResponse> {
    const params = new URLSearchParams({
        tenantId: tenantId.toString()
    });
    if (cloud) params.append('cloud', cloud);
    if (region) params.append('region', region);
    
    return axios.get(
        `${API_V1_URL}/ctxr/-1/healthcheck?${params.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
    )
}
